import React, { useState } from 'react';
import { makeStyles, TextField, InputAdornment } from '~/lib/bn-material-ui';

const useStyles = makeStyles(() => ({
  inlineRow: {
    display: 'flex',
    gap: '1rem',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
    ['& .MuiTypography-root']: {
      whiteSpace: 'nowrap',
    },
  },
}));

export function BnTextField(props) {
  const styles = useStyles();
  const [isDirty, setIsDirty] = useState(false);

  let { errorMessage, unitType, required, ...defaultProps } = props;

  if (required) {
    if (defaultProps.value === '' || defaultProps.value === undefined) {
      errorMessage = 'This is a required field';
    }
  }

  if (defaultProps.type === 'date') {
    throw new Error('BnTextField does not support type="date". Use BnDateField instead.');
  }

  const _onChange = (e) => {
    setIsDirty(true);
    if (props.onChange) {
      props.onChange(e);
    }
  };
  return (
    <div className={styles.inlineRow}>
      <TextField
        {...defaultProps}
        value={defaultProps.value || ''}
        error={isDirty && errorMessage}
        onChange={(e) => _onChange(e)}
        InputProps={{
          ...defaultProps.InputProps,
          ...unitType ? { endAdornment: <InputAdornment position='end'>{props.unitType}</InputAdornment> } : null,
        }}
        InputLabelProps={{
          ...(defaultProps?.InputLabelProps || {}),
        }}
        helperText={isDirty && errorMessage}
      />
    </div>
  );
}
